import * as React from 'react';

import { useHandleAddToCart } from '@sharedComponents/AddToCartButton/sharedComponents/BuyButton/hooks/useHandleAddToCart';
import { IAddToCartCommonParams } from '@sharedComponents/AddToCartButton/sharedComponents/BuyButton/model';
import { LocalRequestHeaders } from '@utils/admin-panel';
import { isDesktop } from '@utils/helpers';

import { useProductDetailContext } from '../ProductDetailContext';

import { useGetProductById } from './useGetProductById';
import { useGetProductByIds } from './useGetProductByIds';

export const useIntegrateSwogo = () => {
  const { currentVariant, product } = useProductDetailContext();
  const { handleAddToCart } = useHandleAddToCart();

  const getProductById = useGetProductById();
  const getProductByIds = useGetProductByIds();

  React.useEffect(() => {
    window._SwogoIntegration = {
      addToCart: async (products) => {
        const productsInfo: IAddToCartCommonParams['products'] =
          await Promise.all(
            products.map(async (p) => {
              const { productCode, annotation, name, masterId } =
                await getProductById(p.internalProductID);
              return {
                id: String(p.internalProductID),
                count: p.quantity,
                productCode,
                variantName: annotation,
                name,
                masterId,
              };
            })
          );

        await handleAddToCart({
          products: productsInfo,
        });
      },
      getPDPSkus: () =>
        product.variants.map((v) => ({
          internalProductID: Number(v.id),
          sku: v.productCode,
          price: v.price.value,
          active: v.canBuy,
          title: `${product.brandInfo.name} ${product.collection || ''}`.trim(),
          quantity: 1,
          isSelectedVariant: v.id === currentVariant.id,
        })),
      getLanguage: () => LocalRequestHeaders.localHeaders.language,
      getPageSize: () => (isDesktop() ? 'Desktop' : 'Mobile'),
      getPageType: () => 'ProductDetail',
      getAvailabilityAndPrice: ({ internalProductID }) =>
        getProductById(internalProductID),
      getAvailabilityAndPriceBatched: ({ internalProductIDs }) =>
        getProductByIds(internalProductIDs),
    };
  }, [
    handleAddToCart,
    product.brandInfo.name,
    product.collection,
    product.variants,
    getProductById,
    getProductByIds,
    currentVariant.id,
  ]);
};
